import { Injectable, inject } from '@angular/core';
import { catchError, forkJoin, of, tap } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { MedicationRequest } from 'fhir/r4';
import { AddMedicationAdministrationComponent } from '../medication-administration/add-medication-administration/add-medication-administration.component';
import { backendEndPointToken } from '../app.config';
import { ErrorService } from '../shared/error.service';

@Injectable({ providedIn: 'root' })
export class MedicineAdministrationDialogService {
    private dialog = inject(MatDialog);
    private http = inject(HttpClient);
    private snackBar = inject(MatSnackBar);
    private backendEndPoint = inject(backendEndPointToken);
    private errorService = inject(ErrorService);

    openAdministrationDialog(medicationRequest?: MedicationRequest): void {
        const dialogRef = this.dialog.open(AddMedicationAdministrationComponent, {
            maxWidth: '900px',
            maxHeight: '90vh',
            data: { medicationRequest }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.http.post(`${this.backendEndPoint}/MedicationAdministration`, result).subscribe({
                    next: () => {
                        this.snackBar.open('Medication administration recorded successfully', 'Close', { duration: 3000 });
                    },
                    error: (err) => {
                        console.error(err);
                        this.errorService.openandCloseError('Failed to record medication administration');
                    }
                });
            }
        });
    }
}
